/**
 * El aviso de quien intenta contratar un plan teniendo ya una membresía.
 *
 * Antes era una línea roja con el texto del servidor, sin nada que hacer con
 * ella. Aquí lleva a donde se resuelve —Facturación, que es donde se cambia de
 * plan, de ciclo o se cancela— con el mismo aspecto que la ventana del alta de
 * Stripe (`StripeOnboardingDialog`), de la que toma los estilos.
 */
import { useEffect } from 'react'
import { IconCreditCard } from '@tabler/icons-react'
import { useI18n } from '../../../lib/i18n'

export function MembershipExistsDialog({ onBilling, onClose }: {
  onBilling: () => void
  onClose: () => void
}) {
  const { t } = useI18n()

  useEffect(() => {
    const onKey = (event: KeyboardEvent) => { if (event.key === 'Escape') onClose() }
    document.addEventListener('keydown', onKey)
    return () => document.removeEventListener('keydown', onKey)
  }, [onClose])

  return (
    <div className="dash-stripe-onboarding" role="presentation" onClick={onClose}>
      <div
        className="dash-stripe-onboarding-card"
        role="dialog"
        aria-modal="true"
        aria-label={t('plans.exists.title')}
        onClick={(event) => event.stopPropagation()}
      >
        <span className="dash-stripe-onboarding-mark is-done" aria-hidden="true">
          <IconCreditCard size={28} />
        </span>
        <h3>{t('plans.exists.title')}</h3>
        <p>{t('plans.exists.body')}</p>
        <button type="button" className="dash-primary-btn" onClick={onBilling}>
          {t('plans.exists.cta')}
        </button>
        <button type="button" className="dash-secondary-btn" onClick={onClose}>
          {t('plans.exists.close')}
        </button>
      </div>
    </div>
  )
}
